/**
 * Catalogos de los documentos clinicos que no son el estudio.
 *
 * Recetas y notas. Igual que el resto: la lista vive aqui, el tipo se deriva de
 * ella, y el backend valida contra lo mismo con lo que el frontend construye la
 * interfaz.
 */
/**
 * Vias de administracion.
 *
 * La lista es corta a proposito: es la que se usa en un consultorio de
 * colposcopia. Un catalogo de cuarenta vias hace que elegir «oral» cueste tres
 * segundos mas, cuarenta veces al dia.
 */
export const VIAS_ADMINISTRACION = [
    'Oral',
    'Vaginal',
    'Tópica',
    'Intramuscular',
    'Intravenosa',
    'Subcutánea',
    'Rectal',
    'Otra',
];
/**
 * Tipos de nota.
 *
 * Los tres que la NOM-004 pide para un consultorio de consulta externa. La
 * **aclaratoria** no es una nota mas: es el mecanismo para corregir algo ya
 * asentado sin borrarlo, y por eso siempre apunta a otro documento.
 */
export const TIPOS_DE_NOTA = ['evolucion', 'egreso', 'aclaratoria'];
/** Como se nombra cada tipo de nota en pantalla y en el documento impreso. */
export const NOMBRE_DE_NOTA = {
    evolucion: 'Nota de evolución',
    egreso: 'Nota de egreso',
    aclaratoria: 'Nota de aclaración',
};
/**
 * Entidades a las que una nota de aclaracion puede referirse.
 *
 * Es la lista de documentos firmados del expediente: lo que ya no se puede
 * cambiar, solo aclarar.
 */
export const DOCUMENTOS_ACLARABLES = [
    'HistoriaClinica',
    'Colposcopia',
    'Receta',
    'NotaEvolucion',
    'NotaEgreso',
];
/** Pronostico, tal como se asienta en una nota. */
export const PRONOSTICOS = ['Bueno', 'Reservado', 'Malo', 'No aplica'];
//# sourceMappingURL=documentos.js.map